export const COUNTRIES = [
  { code: "FR", name: "France" },
  { code: "BE", name: "Belgique" },
  { code: "CH", name: "Suisse" },
  { code: "CA", name: "Canada" },
  { code: "US", name: "États-Unis" },
  { code: "GB", name: "Royaume-Uni" },
  { code: "DE", name: "Allemagne" },
  { code: "ES", name: "Espagne" },
  { code: "IT", name: "Italie" },
  { code: "PT", name: "Portugal" },
  { code: "NL", name: "Pays-Bas" },
  { code: "LU", name: "Luxembourg" },
  { code: "AT", name: "Autriche" },
  { code: "IE", name: "Irlande" },
  { code: "SE", name: "Suède" },
  { code: "DK", name: "Danemark" },
  { code: "NO", name: "Norvège" },
  { code: "FI", name: "Finlande" },
  { code: "PL", name: "Pologne" },
  { code: "CZ", name: "République tchèque" },
  { code: "GR", name: "Grèce" },
  { code: "TR", name: "Turquie" },
  { code: "RU", name: "Russie" },
  { code: "JP", name: "Japon" },
  { code: "CN", name: "Chine" },
  { code: "KR", name: "Corée du Sud" },
  { code: "AU", name: "Australie" },
  { code: "NZ", name: "Nouvelle-Zélande" },
  { code: "ZA", name: "Afrique du Sud" },
  { code: "BR", name: "Brésil" },
  { code: "AR", name: "Argentine" },
  { code: "MX", name: "Mexique" },
  { code: "MA", name: "Maroc" },
  { code: "TN", name: "Tunisie" },
  { code: "DZ", name: "Algérie" },
  { code: "SN", name: "Sénégal" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "OTHER", name: "Autre" }
];
